<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      :breadcrumbs="breadcrumbs"
      icon="mdi-format-list-checkbox"
    ></vuse-section-definition>

    <v-row class="fill-width">
      <v-col cols="8" sm="8">
        <v-row class="mx-3">
          <v-col class="mx-3" cols="3.5" sm="3.5">
            <v-text-field
              background-color="#EDF2F7"
              filled
              v-model="category.keyword_name"
              label="Tên"
              placeholder="Nhập tên category"
              @input="debounceInput"
            ></v-text-field>
          </v-col>
          <v-col class="mx-3" cols="3.5" sm="3.5">
            <v-text-field
                background-color="#EDF2F7"
                filled
                v-model="category.slug"
                label="Slug"
                @keyup="getItem"
            ></v-text-field>
          </v-col>
          <v-col class="mx-3" cols="3.5" sm="3.5">
            <v-select
              background-color="#EDF2F7"
              filled
              v-model="category.brand_id"
              :items="brandsSelect"
              item-text="name"
              item-value="id"
              label="Chọn nhãn hàng"
              @change="getItem"
            ></v-select>
          </v-col>
          <v-col class="mx-3" cols="3.5" sm="3.5">
            <v-autocomplete
              background-color="#EDF2F7"
              filled
              v-model="category.parent_id"
              :items="categories"
              item-text="name"
              item-value="id"
              clearable
              label="Danh mục cha"
              @change="getItem"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="4" sm="4" align="right">
        <v-btn color="primary" align="right" @click="addNew" v-if="hasPermissions('Create category product')">
          Thêm category
        </v-btn>
      </v-col>
    </v-row>

    <v-container fluid>
      <v-row justify="center" align="center">
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="dataResult"
            :page.sync="page_number"
            :items-per-page="itemsPerPage"
            class="elevation-1"
            @page-count="pageCount = $event"
          >
          <template v-slot:item.photo_url="{ item }" >
                <img width="80" :src="item && item.photo_url ? item.photo_url: require('@/assets/images/bi_image.png')">
            </template>
            <template v-slot:item.brand_photo_url="{ item }" >
              <img class="img-brand" :src="item.brand_photo_url ? item.brand_photo_url : require('@/assets/images/bi_image.png')">
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)" v-if="hasPermissions('Update category product')">
                mdi-pencil
              </v-icon>
              <!--              <v-icon small class="mr-2" @click="reviewItem(item.id)">-->
              <!--                mdi-eye-->
              <!--              </v-icon>-->
              <v-icon small @click="deleteItem(item.id)" v-if="hasPermissions('Delete category product')"> mdi-delete </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import {
  DELETE_CATEGORY,
  GET_DATA_SEARCH,
} from "@/store/modules/category";
import { GET_LIST_BRAND } from "@/store/modules/brand";
import { mapGetters } from "vuex";
import {debounce} from "debounce";

export default {
  data() {
    return {
      current_page: 1,
      page_number: 1,
      pageCount: 0,
      itemsPerPage: 10,
      page: "Quản lý category",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý sản phẩm",
          disabled: true,
        },
        {
          text: "Quản lý category",
          disabled: true,
        },
      ],
      category: {
        keyword_name: "",
        parent_id: null,
        brand_id: null,
        description: "",
        slug: "",
        list_media: [],
        list_attribute: [],
        is_group_template: false,
        is_comparable: false,
        limit: 10,
      },

      headers: [
        { text: "ID", value: "id" },
        {
          text: "Hình ảnh",
          align: "start",
          sortable: false,
          value: "photo_url",
        },
        { text: 'Tên', value: 'name' },
        { text: 'Tên Gợi nhớ', value: 'reminiscent_name' },
        { text: 'Nhãn hàng', value: 'brand_photo_url' },
        // { text: 'Danh mục cha', value: 'parent_category_name' },
        { text: 'Actions', value: 'actions' },
      ],
      url: "",
    };
  },
  computed: {
    ...mapGetters({
      categories: "categories",
      brands: "brands",
      dataResult: "dataSearch",
    }),
    brandsSelect() {
      let arr = [...this.brands];
      arr.unshift({ id: "-1", name: "Chọn tất cả" });
      return arr;
    },
  },

  watch: {
    // categories: function (val) {
    //   console.log("catgories: ", val);
    // },
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL;
    this.page_number = parseInt(this.$route.query.page_current) || 1
    this.category.keyword_name =  this.$route.query.name || ''
    this.category.slug = this.$route.query.slug || ''
    this.category.brand_id = parseInt(this.$route.query.brand_id) || ''
    this.category.parent_id =  parseInt(this.$route.query.parent_id) || 0
    this.params();
    await this.$store.dispatch(GET_LIST_BRAND);
  },
  methods: {
    replaceCategory() {
      this.$router.replace({
        query: {
          name: this.category.keyword_name,
          slug: this.category.slug,
          brand_id: this.category.brand_id != "-1" ? this.category.brand_id : null,
          parent_id: this.category.parent_id != "-1" ? this.category.parent_id : null,
          page_current: parseInt(this.page_number),
        }
      })
    },
    params() {
      let param = {
        name: this.category.keyword_name,
        slug: this.category.slug,
        brand_id: this.category.brand_id != "-1" ? this.category.brand_id : null,
        parent_id: this.category.parent_id != "-1" ? this.category.parent_id : null,
      };
      this.$store.dispatch(GET_DATA_SEARCH, param);
    },
    debounceInput: debounce(function (e) {
      this.category.keyword_name = e;
      this.params();
      this.replaceCategory();
    }, 200),
    getItem() {
      this.replaceCategory();
      this.params();
    },
    editItem(item) {
      this.replaceCategory();
      this.$router.push(
        "/manage_productions/category/edit_category/" + item.id
      );
    },
    reviewItem(id) {
      this.$router.push(
        `/manage_productions/category/detail_category/${id}`
      );
    },
    deleteItem(id) {
      confirm("Bạn có chắc muốn xóa?") &&
        this.$store.dispatch(`${DELETE_CATEGORY}`, id).then((data) => {
          if (data && data.status === 1) {
            this.$store.dispatch(GET_DATA_SEARCH);
          }
        });
    },
    addNew() {
      this.$router.push("/manage_productions/category/add_category");
    },
  },
};
</script>
<style lang="scss">
.content_category1 {
  background: #ffffff !important;
}
.img-brand {
  max-width: 100px;
  max-height: 100px;
  margin: auto;
  display: block;
}
</style>
